/**
 * Om rutinens legobitar visar stegens NAMN.
 *
 * Bitarna finns för att den som inte läser ändå ska se hur många steg som är kvar —
 * därför är grundläget utan namn. Men den som läser har nytta av att se vad som ligger
 * i varje bit, så HANDLEDAREN får slå på namnen per brukare.
 *
 * Valet ägs alltså av handledaren och bor på kontot (users.routine_step_labels, V010).
 * localStorage-nyckeln nedan är en SPEGLING av kontots värde, inte en egen sanning:
 * den skrivs när användaren läses in (AppContext) och läses av vyerna. Samma mönster,
 * och samma skäl, som utils/timerDisplay.ts — rutinkortet ska rita rätt bitar redan
 * vid första rendering, utan att vänta på servern.
 *
 * Efter setItem dispatchas 'storage' manuellt: webbläsaren fyrar annars bara eventet i
 * ANDRA flikar, inte i den som gjorde ändringen (jfr childMode.ts, npfNudges.ts).
 */
const ROUTINE_STEP_LABELS_KEY = 'routineStepLabels';

/** Utan namn. Ett saknat eller oläsbart värde tolkas alltid som detta. */
export const DEFAULT_ROUTINE_STEP_LABELS = false;

export const getRoutineStepLabels = (): boolean =>
  localStorage.getItem(ROUTINE_STEP_LABELS_KEY) === 'true';

export const setRoutineStepLabels = (labels: boolean): void => {
  localStorage.setItem(ROUTINE_STEP_LABELS_KEY, labels ? 'true' : 'false');
  window.dispatchEvent(new Event('storage'));
};
